import React, { useRef, useState } from 'react';
import {
  ButtonsContainer,
  CustomTextArea,
  DetailsContainer,
  FilePreviewCloseIcon,
  FilePreviewContainer,
  FilterPersonsList,
  FilterPersonsListItem,
  IconsContainer,
  InputAndActionsContainer,
  ViewContainer,
} from './EditComment.styles';
import Me from '../../../_types/Me';
import MyPerson from '../_types/MyPerson';
import UserProfilePicture from '../../../components/UserProfilePicture';
import EditCommentArgs from '../_types/EditCommentArgs';
import { Icon } from '../FeedItem/contents/Actions/Actions.styles';
import GifSearch from '../GifSearch';
import { useTheme } from '../../../context/PermissionsContext/ThemeContext/ThemeContext';
import ConfirmationDialog from '../../../components/ConfirmationDialog';

interface Props {
  comment: EditCommentArgs;
  me: Me;
  myPersons: MyPerson[];
  filePreview: any;
  openGif: boolean;
  onChangeComment: (comment: EditCommentArgs) => void;
  onUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onOpenCloseGif: () => void;
  onUpdateComment: () => Promise<void>;
  onRemoveFilePreview: () => void;
  onChangeIsUpdating: (newIsEditing: boolean) => void;
}
const EditCommentView = ({
  filePreview,
  me,
  myPersons,
  onChangeComment,
  onOpenCloseGif,
  onUpdateComment,
  onUpload,
  openGif,
  comment,
  onRemoveFilePreview,
  onChangeIsUpdating,
}: Props) => {
  const uploadRef = useRef<any>();
  const [filteredMyPersons, setFilteredMyPersons] = useState<MyPerson[]>([]);
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
  const { theme } = useTheme();

  const handleTextChange = (value: string) => {
    onChangeComment({ ...comment, content: value });

    const lastWord = (value.split(' ').pop() || '').toLowerCase();

    if (lastWord.startsWith('@')) {
      setFilteredMyPersons(
        myPersons.filter((myPerson) =>
          myPerson.name.toLowerCase().includes(lastWord.slice(1))
        )
      );
    } else {
      setFilteredMyPersons([]);
    }
  };

  console.log('How do I get here??');

  return (
    <>
      <ConfirmationDialog
        open={openRemoveDialog}
        onClose={() => setOpenRemoveDialog(false)}
        onConfirm={() => {
          onRemoveFilePreview();
          onChangeComment({
            ...comment,
            imageName: '',
            imageType: '',
          });
          uploadRef.current.value = '';
          setOpenRemoveDialog(false);
        }}
        title="Are you sure you wish to remove this attachment?"
      />
      <ViewContainer
        style={{
          backgroundColor: theme.isDark ? theme.background3 : theme.background1,
        }}
      >
        <UserProfilePicture
          imageName={me.imageName || ''}
          initials={me?.name}
        />
        <DetailsContainer>
          <CustomTextArea
            style={{
              backgroundColor: theme.isDark
                ? theme.background3
                : theme.background1,
              color: theme.text,
            }}
            maxLength={255}
            value={comment.content}
            onChange={(e) => handleTextChange(e.target.value)}
            placeholder={`What's happening?`}
          />
          {filePreview ? (
            <FilePreviewContainer>
              <FilePreviewCloseIcon
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenRemoveDialog(true);
                }}
                src="/images/close.svg"
              />
              {comment.imageType === 'video' ? (
                <video width="320" height="240" controls>
                  <source src={filePreview} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              ) : (
                <img src={filePreview} alt="Preview" width="200" />
              )}
            </FilePreviewContainer>
          ) : null}

          <InputAndActionsContainer>
            <IconsContainer>
              <input
                onChange={(e) => onUpload(e)}
                style={{ display: 'none' }}
                accept="image/*,video/*"
                type="file"
                ref={(ref) => (uploadRef.current = ref)}
              />
              <div style={{ position: 'relative' }}>
                <Icon
                  onClick={() => handleTextChange('@')}
                  src="/images/icon-at.svg"
                />
                {filteredMyPersons.length > 0 ? (
                  <FilterPersonsList>
                    {filteredMyPersons.map((myPerson) => (
                      <FilterPersonsListItem
                        onClick={() => {
                          const currentText = comment.content;
                          const newText = currentText.replace(
                            /@\w*$/,
                            `@${myPerson.name} `
                          );
                          handleTextChange(newText);
                        }}
                        key={myPerson.id}
                      >
                        <UserProfilePicture
                          imageName={myPerson.imageName}
                          initials={myPerson?.name}
                        />
                        <div style={{ fontWeight: 600 }}>{myPerson.name}</div>
                      </FilterPersonsListItem>
                    ))}
                  </FilterPersonsList>
                ) : null}
              </div>

              <Icon
                onClick={() => uploadRef.current.click()}
                src="/images/icon-image.svg"
              />
              <div style={{ position: 'relative' }}>
                <Icon onClick={onOpenCloseGif} src="/images/icon-gif.svg" />
                <GifSearch
                  open={openGif}
                  onOpenClose={onOpenCloseGif}
                  onSelect={(gif: any) => {
                    onChangeComment({
                      ...comment,
                      imageName: gif.url,
                      imageType: 'gif_url',
                    });
                  }}
                />
              </div>
            </IconsContainer>

            <ButtonsContainer>
              <div
                onClick={() => onChangeIsUpdating(false)}
                style={{
                  cursor: 'pointer',
                  borderRadius: 12,
                  backgroundColor: 'transparent',
                  border: '1px solid #FF6A00',
                  color: '#FF6A00',
                  fontWeight: 600,
                  padding: '10px 20px',
                  textAlign: 'center',
                }}
              >
                Cancel
              </div>
              <div
                onClick={onUpdateComment}
                style={{
                  cursor: 'pointer',
                  backgroundColor: '#FF6A00',
                  color: '#fff',
                  fontWeight: 600,
                  padding: '10px 20px',
                  borderRadius: 12,
                  textAlign: 'center',
                }}
              >
                Save
              </div>
            </ButtonsContainer>
          </InputAndActionsContainer>
        </DetailsContainer>
      </ViewContainer>
    </>
  );
};

export default EditCommentView;
